import FirstStep from "./firstStep"
import FourthStep from "./fourthStep"
import SecondStep from "./secondStep"
import ThirdStep from "./thirdStep"

const ListServiceSteps = [FirstStep, SecondStep, ThirdStep, FourthStep]

export default ListServiceSteps
